<template>
	<div>
		<!-- <van-nav-bar title="在线画图" /> -->
		<droup-down @selectColor='selectColor' @selectCard='selectCard' @selectImage='selectImage'
			@uploadImage='uploadImage' @circle='circle' @clickFunc='clickFunc' @inputFont='inputFont'></droup-down>
		<canvas id="myCanvas"></canvas>
		<van-action-sheet v-model:show="show" title="标题">
			<div class="content">内容</div>
		</van-action-sheet>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant'
	import DroupDown from './components/droup-down/droup-down.vue'
	export default {
		name: 'HelloWorld',
		components: {
			DroupDown
		},
		data() {
			return {
				canvas: null,
				show: false,
				cardType: '自由绘图',
				mouseFrom: {
					x: 0,
					y: 0
				},
				mouseTo: {
					x: 0,
					y: 0
				},
				color: '#000',
				lineWidth: 4,
				backgroundColor: '#fff',
				drawingObject: null,
				textObject: null,
				textObjectFlag: false,
				cxFlag: false
			}
		},
		mounted() {
			let that = this
			let clientWidth = document.documentElement.clientWidth
			let clientHeight = document.documentElement.clientHeight - 50
			document.getElementById('myCanvas').width = clientWidth
			document.getElementById('myCanvas').height = clientHeight
			that.canvas = new fabric.Canvas('myCanvas')
			that.canvas.on('mouse:down', function(options) {
				that.mousedown(options);
			});
			that.canvas.on('mouse:move', function(options) {
				that.mousemove(options);
			});
			that.canvas.on("selection:created", function(e) {
				if (that.cxFlag) {
					that.canvas.remove(e.selected[0]);
					that.canvas.discardActiveObject(); //清楚选中框
				}
			});
			if (that.cardType == '自由绘图') {
				that.drawLine();
			}
			that.canvas.preserveObjectStacking = true
		},
		methods: {
			//获取参数传值
			getQuery(name) {
				// 正则：[找寻'&' + 'url参数名字' = '值' + '&']（'&'可以不存在）
				let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
				let r = window.location.search.substr(1).match(reg);
				if (r != null) {
					// 对参数值进行解码
					return decodeURIComponent(r[2]);
				}
				return null;
			},
			//获取笔刷颜色
			selectColor(color, lineWidth) {
				this.cxFlag = false
				this.canvas.selection = true;
				this.canvas.skipTargetFind = true; //画板元素不能被选中
				this.canvas.selection = false; //画板元素不能被选中
				this.canvas.freeDrawingBrush.color = color
				this.canvas.freeDrawingBrush.width = lineWidth
				this.lineWidth = lineWidth
				this.color = color
			},
			//选择图形
			selectCard(type) {
				this.textObjectFlag = false //关闭写字
				this.cxFlag = false
				this.canvas.skipTargetFind = true; //画板元素不能被选中
				this.canvas.selection = false; //画板元素不能被选中
				//关闭自由绘画
				this.canvas.isDrawingMode = false
				this.cardType = type
				if (type == '自由绘图') {
					this.drawLine();
				}
			},
			// 因为画布会进行移动或缩放，所以鼠标在画布上的坐标需要进行相应的处理才是相对于画布的可用坐标
			getTransformedPosX(x) {
				let zoom = Number(this.canvas.getZoom())
				return (x - this.canvas.viewportTransform[4]) / zoom;
			},
			getTransformedPosY(y) {
				let zoom = Number(this.canvas.getZoom())
				return (y - this.canvas.viewportTransform[5]) / zoom;
			},
			//鼠标摁下
			mousedown(options) {
				this.mouseFrom.x = options.pointer.x
				this.mouseFrom.y = options.pointer.y
				this.drawingObject = null
				if (this.textObjectFlag) {
					this.clickFont()
				}
			},
			//鼠标移动
			mousemove(options) {
				if (options.target != null) {
					return
				}
				this.mouseTo.x = options.pointer.x
				this.mouseTo.y = options.pointer.y
				if (this.cardType != '自由绘图') {
					this.drawIng()
				}
			},
			//绘画
			drawIng() {
				if (this.drawingObject) {
					this.canvas.remove(this.drawingObject);
				}
				let canvasObject = null
				switch (this.cardType) {
					case '三角形':
						canvasObject = this.drawTringle(canvasObject)
						break;
					case '长方形':
						canvasObject = this.drawRect(1, canvasObject)
						break;
					case '正方形':
						canvasObject = this.drawRect(2, canvasObject)
						break;
					case '圆形':
						canvasObject = this.drawCircle(canvasObject)
						break;
					case '五角星':
						canvasObject = this.drawStart(canvasObject)
						break;
					case '箭头':
						canvasObject = this.drawArrow(canvasObject)
						break;
					case '直线':
						canvasObject = this.drawLineMap(canvasObject)
						break;
				}
				if (canvasObject) {
					this.canvas.add(canvasObject);
					this.drawingObject = canvasObject;
				}
			},
			// 绘制矩形
			drawRect(type, canvasObject) {
				// 计算矩形长宽
				let left = this.getTransformedPosX(this.mouseFrom.x);
				let top = this.getTransformedPosY(this.mouseFrom.y);
				let width = this.mouseTo.x - this.mouseFrom.x;
				let height = this.mouseTo.y - this.mouseFrom.y;
				// 创建矩形 对象
				canvasObject = new fabric.Rect({
					left: left,
					top: top,
					width: width,
					height: type == 1 ? height : width,
					strokeWidth: this.lineWidth,
					stroke: this.color,
					fill: this.backgroundColor
				});
				// 绘制矩形
				return canvasObject
			},
			//画直线
			drawLineMap(canvasObject) {
				canvasObject = new fabric.Line([this.mouseFrom.x, this.mouseFrom.y, this.mouseTo.x, this.mouseTo.y], {
					stroke: this.color,
					strokeWidth: this.lineWidth
				});
				return canvasObject
			},
			//自由绘图
			drawLine() {
				// 开启画布自由绘画模式
				this.canvas.isDrawingMode = true;
				// 设置自由绘画模式画笔类型为 铅笔类型
				this.canvas.freeDrawingBrush = new fabric.PencilBrush(this.canvas);
				// 设置自由绘画模式 画笔颜色与画笔线条大小
				this.canvas.freeDrawingBrush.color = this.color;
				this.canvas.freeDrawingBrush.width = this.lineWidth;
			},
			//绘制圆形
			drawCircle(canvasObject) {
				let left = this.getTransformedPosX(this.mouseFrom.x);
				let top = this.getTransformedPosY(this.mouseFrom.y);
				// 计算圆形半径
				let radius =
					Math.sqrt(
						(this.getTransformedPosX(this.mouseTo.x) - left) *
						(this.getTransformedPosY(this.mouseTo.x) - left) +
						(this.getTransformedPosX(this.mouseTo.y) - top) *
						(this.getTransformedPosY(this.mouseTo.y) - top)
					) / 2;
				// 创建 原型对象
				canvasObject = new fabric.Circle({
					left: left,
					top: top,
					stroke: this.color,
					fill: this.backgroundColor,
					radius: radius,
					strokeWidth: this.lineWidth,
				});
				return canvasObject
			},
			//绘制三角形
			drawTringle(canvasObject) {
				let left = this.getTransformedPosX(this.mouseFrom.x);
				let top = this.getTransformedPosY(this.mouseFrom.y);
				let width = this.mouseTo.x - this.mouseFrom.x
				let height = this.mouseTo.y - this.mouseFrom.y
				canvasObject = new fabric.Triangle({
					width: width,
					height: height,
					fill: this.backgroundColor,
					left: left,
					top: top,
					stroke: this.color,
					strokeWidth: this.lineWidth
				})
				return canvasObject
			},
			//绘制五角星
			drawStart(canvasObj) {
				let left = this.getTransformedPosX(this.mouseFrom.x);
				let top = this.getTransformedPosY(this.mouseFrom.y);
				let R = this.mouseTo.x - this.mouseFrom.x
				let r = R / 2
				let points = []
				for (var i = 0; i < 6; i++) {
					// 外顶点(x1,y1)  内顶点(x2,y2)
					var x1 = Math.cos((18 + 72 * i) / 180 * Math.PI) * R,
						y1 = Math.sin((18 + 72 * i) / 180 * Math.PI) * -R,
						x2 = Math.cos((54 + 72 * i) / 180 * Math.PI) * r,
						y2 = Math.sin((54 + 72 * i) / 180 * Math.PI) * -r;
					let obj1 = {
						x: x1 + left,
						y: y1 + top
					}
					let obj2 = {
						x: x2 + left,
						y: y2 + top
					}
					points.push(obj1)
					points.push(obj2)
				}
				canvasObj = new fabric.Polyline(points, {
					fill: this.backgroundColor,
					strokeWidth: this.lineWidth,
					stroke: this.color,
					left: left,
					top: top
				})
				return canvasObj
			},
			//绘制箭头
			drawArrow(canvasObject) {
				canvasObject = new fabric.Path(this.drawArrowFunction(this.mouseFrom.x, this.mouseFrom.y, this.mouseTo
					.x, this.mouseTo.y, 25, 25), {
					stroke: this.color,
					fill: "rgba(255,255,255,0)",
					strokeWidth: this.lineWidth
				});
				return canvasObject
			},
			//绘制箭头方法
			drawArrowFunction(fromX, fromY, toX, toY, theta, headlen) {
				theta = typeof theta != "undefined" ? theta : 30;
				headlen = typeof theta != "undefined" ? headlen : 10;
				// 计算各角度和对应的P2,P3坐标
				var angle = Math.atan2(fromY - toY, fromX - toX) * 180 / Math.PI,
					angle1 = (angle + theta) * Math.PI / 180,
					angle2 = (angle - theta) * Math.PI / 180,
					topX = headlen * Math.cos(angle1),
					topY = headlen * Math.sin(angle1),
					botX = headlen * Math.cos(angle2),
					botY = headlen * Math.sin(angle2);
				var arrowX = fromX - topX,
					arrowY = fromY - topY;
				var path = " M " + fromX + " " + fromY;
				path += " L " + toX + " " + toY;
				arrowX = toX + topX;
				arrowY = toY + topY;
				path += " M " + arrowX + " " + arrowY;
				path += " L " + toX + " " + toY;
				arrowX = toX + botX;
				arrowY = toY + botY;
				path += " L " + arrowX + " " + arrowY;
				return path;
			},
			//选择绘制图片
			selectImage(image) {
				this.textObjectFlag = false
				this.canvas.skipTargetFind = false; //画板元素能被选中
				this.canvas.selection = true; //画板元素能被选中
				//关闭自由绘画模式
				this.canvas.isDrawingMode = false;
				let url = null
				switch (image) {
					case 'icon-1':
						url =
							"data:image/png;base64,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"
						break;
					case 'icon-2':
						url =
							'data:image/png;base64,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'
						break;
					case 'icon-3':
						url =
							'data:image/png;base64,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'
						break;
				}
				fabric.Image.fromURL(url, (res) => {
					this.canvas.add(res)
				})
			},
			//选择本地图片
			uploadImage(content) {
				this.canvas.isDrawingMode = false;
				this.canvas.skipTargetFind = false; //画板元素能被选中
				this.canvas.selection = true; //画板元素能被选中
				fabric.Image.fromURL(content, (res) => {
					res.scale(0.1)
					this.canvas.add(res)
				})
			},
			//功能
			clickFunc(type) {
				switch (type) {
					case 'xpc':
						this.cxFlag = false
						this.textObjectFlag = false
						this.cardType = '自由绘图'
						this.canvas.isDrawingMode = true;
						// 设置自由绘画模式画笔类型为 铅笔类型
						this.canvas.freeDrawingBrush = new fabric.PencilBrush(this.canvas);
						// 设置自由绘画模式 画笔颜色与画笔线条大小
						this.canvas.freeDrawingBrush.color = this.backgroundColor;
						this.canvas.freeDrawingBrush.width = this.lineWidth;
						break;
					case 'clear':
						this.cxFlag = false
						let children = this.canvas.getObjects()
						if (children.length > 0) {
							// 移除所有对象
							this.canvas.remove(...children)
						}
						break;
					case 'saveCanvas':
						this.export()
						this.cxFlag = false
						break;
					case 'cx':
						this.cxFlag = true
						this.canvas.isDrawingMode = false
						this.canvas.selection = true;
						this.canvas.skipTargetFind = false; //画板元素能被选中
						this.canvas.selectable = true; //画板元素能被选中
						break;
				}
			},
			//输入文字
			inputFont() {
				this.canvas.skipTargetFind = true; //画板元素不能被选中
				this.canvas.selection = false; //画板元素不能被选中
				this.textObjectFlag = true
				this.canvas.isDrawingMode = false
				Toast('请点击要输入文字的地方');
			},
			//写字
			clickFont() {
				if (!this.textObject) {
					// 当前不存在绘制中的文本对象，鼠标第一次按下
					// 根据鼠标按下的起点坐标文本对象
					this.textObject = new fabric.Textbox("", {
						left: this.getTransformedPosX(this.mouseFrom.x),
						top: this.getTransformedPosY(this.mouseFrom.y),
						fontSize: this.lineWidth,
						fill: this.color,
						hasControls: false,
						editable: true,
						backgroundColor: "#fff",
						selectable: false,
					});
					this.canvas.add(this.textObject);
					// 文本打开编辑模式
					this.textObject.enterEditing();
					// 文本编辑框获取焦点
					this.textObject.hiddenTextarea.focus();
				} else {
					// 鼠标第二次按下 将当前文本对象退出编辑模式
					this.textObject.exitEditing();
					this.textObject.set("backgroundColor", "rgba(0,0,0,0)");
					if (this.textObject.text == "") {
						this.canvas.remove(this.textObject);
					}
					this.canvas.renderAll();
					this.textObject = null;
					return;
				}
			},
			//保存画布
			export () {
				let that = this
				// 因为我们需要给初始视口区域外的部分添加背景色，所以通过克隆画布去实现，不修改原画布
				this.canvas.clone(cvs => {
					//遍历所有对对象，获取最小坐标，最大坐标，根据画布中图形的最小坐标与最大坐标计算导出内容的左上角坐标以及导出内容的宽高
					let top = 0
					let left = 0
					let width = this.canvas.width
					let height = this.canvas.height

					var objects = cvs.getObjects();
					if (objects.length > 0) {
						var rect = objects[0].getBoundingRect();
						var minX = rect.left;
						var minY = rect.top;
						var maxX = rect.left + rect.width;
						var maxY = rect.top + rect.height;
						for (var i = 1; i < objects.length; i++) {
							rect = objects[i].getBoundingRect();
							minX = Math.min(minX, rect.left);
							minY = Math.min(minY, rect.top);
							maxX = Math.max(maxX, rect.left + rect.width);
							maxY = Math.max(maxY, rect.top + rect.height);
						}
						// 给上下左右添加100px的间距，这样导出的图形不会刚好贴合最边缘的图形而是有一定的间隙。
						top = minY - 100
						left = minX - 100
						width = maxX - minX + 200
						height = maxY - minY + 200
						// 给当前画布添加颜色与背景色相同的矩形，解决初始视口外区域底色为透明的问题。
						cvs.sendToBack(new fabric.Rect({
							left,
							top,
							width,
							height,
							stroke: 'rgba(0,0,0,0)',
							fill: this.bgColor,
							strokeWidth: 0
						}))
					}
					// 将画布导出成base64格式数据
					const dataURL = cvs.toDataURL({
						format: 'png',
						multiplier: cvs.getZoom(),
						left,
						top,
						width,
						height
					});
					uni.postMessage({
						data: dataURL + '&' + this.getQuery('projectId')
					});
					// this.axios.post('DilimsUploadServlet', {
					// 	recordId: this.getQuery('projectId'),
					// 	// recordId: '402883b080509ed6018050a370750006',
					// 	type: 1,
					// 	file: that.base64toFile(dataURL,'docpic.jpg')
					// }, {
					// 	headers: {
					// 		'Content-Type': 'multipart/form-data'
					// 	}
					// }).then(res => {
					// 	uni.postMessage({
					// 		data: res.data
					// 	});
					// }).catch(error => {
					// 	uni.postMessage({
					// 		data: error
					// 	});
					// })
				})
			},
			//添加图标
			circle(number) {
				this.canvas.skipTargetFind = false; //画板元素能被选中
				this.canvas.selection = true; //画板元素能被选中
				this.canvas.isDrawingMode = false;
				var circle = new fabric.Circle({
					radius: 30,
					fill: '#eef',
					originX: 'center',
					originY: 'center'
				});
				var text = new fabric.Text(number, {
					fontSize: 14,
					originX: 'center',
					originY: 'center'
				});
				var group = new fabric.Group([circle, text], {
					left: 30,
					top: 30
				});
				this.canvas.add(group)
			},
			base64toFile(dataurl, filename) {
				var arr = dataurl.split(','),
					mime = arr[0].match(/:(.*?);/)[1],
					bstr = atob(arr[1]),
					n = bstr.length,
					u8arr = new Uint8Array(n)
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n)
				}
				return new File([u8arr], filename, {
					type: mime
				})
			},
			// base64toFile(dataurl, filename = 'file') {
			// 	let arr = dataurl.split(',')
			// 	let mime = arr[0].match(/:(.*?);/)[1]
			// 	let suffix = mime.split('/')[1]
			// 	let bstr = atob(arr[1])
			// 	let n = bstr.length
			// 	let u8arr = new Uint8Array(n)
			// 	while (n--) {
			// 		u8arr[n] = bstr.charCodeAt(n)
			// 	}
			// 	return new File([u8arr], `${filename}.${suffix}`, {
			// 		type: mime
			// 	})
			// },
		}
	}
</script>

<style scoped>
	.content {
		padding: 16px 16px 160px;
	}
</style>
